// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_props) {
    return null;
}
Column.defaultProps = {
    width: 100,
    hideable: true,
    hidden: false,
    fixed: false,
    sortable: false,
};
export const ColumnPropTypeKeys = [
    'align',
    'verticalAlign',
    'width',
    'fixed',
    'resizable',
    'sortable',
    'flexGrow',
    'minWidth',
    'colSpan',
    'sort',
    'treeCol',
    'hidden',
    'hideable',
    'titleEditable',
    'onResize',
    'render',
    'dataIndex',
];
Column.__PFM_TABLE_COLUMN = true;
export default Column;
